'use client'
import { useRef } from 'react'
import Link from 'next/link'
import { torsCats } from 'config/const'
import { getResizedImg } from 'utils/media'
import { useDraggable } from 'react-use-draggable-scroll'

const CardsLarge = ({ tors }) => {
  const ref = useRef()
  const { events } = useDraggable(ref)

  return (
    <div className="bg-white">
      <div className="mx-auto max-w-screen-2xl py-12 px-4 sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-12">
          <div className="space-y-5 sm:space-y-4 md:max-w-xl lg:max-w-3xl xl:max-w-none">
            <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-blue">
              Esdeveniments en curs
            </h2>
          </div>
          <div className="relative">
            {/* {tors.length > 3 && ( */}
            <div className="absolute block h-full z-10 right-0 w-4 from-sec-grey-4 bg-gradient-to-l" />
            <ul
              role="list"
              className="cards-large-home grid gap-4 lg:gap-6 overflow-x-scroll lg:overflow-x-hidden"
              {...events}
              ref={ref}
            >
              {tors.map((tor) => {
                const torInfo = torsCats.find(
                  ({ id }) => tor.CategoryFilter?.toLowerCase() === id
                )
                const link =
                  tor?.Link ||
                  `${torInfo.torUrl}/${tor.Year}/${tor.Slug}/informacio`
                return (
                  <li key={tor.Name}>
                    <Link href={link} className="group">
                      <div className="aspect-h-4">
                        <img
                          className="object-cover shadow-lg"
                          src={
                            tor?.Poster
                              ? tor.Poster
                              : tor.Image1
                              ? getResizedImg(tor.Image1)
                              : `/assets/images/tors-posters/${
                                  torInfo.poster || torInfo.keyword
                                }.webp`
                          }
                          alt={tor.Name}
                        />
                      </div>

                      <div className="transition-colors ease-out bg-sec-grey-4 group-hover:bg-accent min-h-[120px]">
                        <div className="flex h-full space-y-1 text-2xl font-medium leading-6 justify-center items-center">
                          <p className="text-black font-alliance-medium text-[24px] lg:text-[30px] p-4 lg:p-6 leading-9">
                            {tor.Name}
                          </p>
                          <img
                            className="ml-auto mr-6 w-10"
                            src="/assets/link-arrow.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </Link>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CardsLarge
